const MechanicTypeEnum = Object.freeze({
    range: Symbol('range'),
    option: Symbol('option'),
    aggregator: Symbol('aggregator')
});

export default MechanicTypeEnum;